import { Provider } from 'react-redux';

import { ConnectedRouter } from 'connected-react-router';
import { Global } from '@emotion/react';
import { store, history } from 'data_system/affiliate_portal/store/store';
import { cssReset } from 'ui_system/token_auth/styles_root';

import { AffiliatePortal } from './AffiliatePortal';

export function Root(props) {
  return (
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <Global styles={cssReset({ fontSize: '14px', lineHeight: 1.2 })} />
        <AffiliatePortal {...props} />
      </ConnectedRouter>
    </Provider>
  );
}
